// extracted by mini-css-extract-plugin
export default {"footer-links-list":"b2y1o"};